import React, { createContext, useState } from "react";
import classnames from "classnames";

const styles = require("./styles.module.scss");

export const TabSwitcherContext = createContext({
  activePanel: "",
  changeActivePanel: (panelName: string) => {},
});

type TabSelectorProps = {
  label: string;
};

const TabSelector: React.FC<TabSelectorProps> = ({ label }) => (
  <TabSwitcherContext.Consumer>
    {({ activePanel, changeActivePanel }) => {
      const isSelected = activePanel === label;

      return (
        <li
          className={classnames(styles.navBarItem, { [styles.isActive]: isSelected })}
          onClick={() => changeActivePanel(label)}
        >
          {label}
          {isSelected && (
            <i className={classnames("fa", "fa-check-circle", styles.selectedCheckIcon)} />
          )}
        </li>
      );
    }}
  </TabSwitcherContext.Consumer>
);

type PanelProps = {
  label: string;
};
const Panel: React.FC<PanelProps> = ({ children, label }) => (
  <TabSwitcherContext.Consumer>
    {({ activePanel }) => (
      <div className={`${activePanel !== label && styles.panelHidden}`}>{children}</div>
    )}
  </TabSwitcherContext.Consumer>
);

const TabSwitcher: React.FC & { Panel: typeof Panel } = ({ children }) => {
  const tabLabelsToRender = [];
  React.Children.forEach(children, child => {
    // @ts-ignore
    if (child.type.name && child.type.name !== Panel.name) {
      console.error(`children of ${TabSwitcher.name} must <${Panel.name}/> components`);
    }
    // @ts-ignore
    const { label } = child.props;
    if (label) {
      tabLabelsToRender.push(label);
    }
  });

  let initialActiveLabel = "";
  const childrenAsArray = React.Children.toArray(children);
  if (childrenAsArray.length !== 0) {
    // @ts-ignore - make more robust later, React.children could be an empty list
    initialActiveLabel = childrenAsArray[0].props.label;
  }
  const [activePanel, setActivePanel] = useState(initialActiveLabel);

  // Render()
  const renderTabs = () =>
    tabLabelsToRender.map(label => <TabSelector key={label} label={label} />);

  const renderPanels = () => children; // Assumes children are only Panel components

  return (
    <TabSwitcherContext.Provider
      value={{
        activePanel,
        changeActivePanel: label => setActivePanel(label),
      }}
    >
      <div className={styles.navBarContainer}>
        <ul>{renderTabs()}</ul>
      </div>
      <div className={styles.panelWrapper}>{renderPanels()}</div>
    </TabSwitcherContext.Provider>
  );
};
TabSwitcher.Panel = Panel;

export default TabSwitcher;
